export default __webpack_public_path__ + "static/media/bise-white.59e3b305.svg";